import { themeVariables } from "Components/theme";
import { Popover } from "Components/withPopover";
import flatMap from "lodash/flatMap";
import size from "lodash/size";
import values from "lodash/values";
import React, { useCallback, useEffect, useRef } from "react";
import { NEW_SCRIPT } from "Areas/Sidebar/DocumentsFloat/constants";
import MethodsSubMenu from "../methodsSubMenu";
import locale from "./methodsBottomPanel.locale";
import { Button } from "UiKit";
import styles from "./methodsBottomPanel.module.css";
import map from "lodash/map";
const methodsBottomPanelId = "methods_sidebar_bottom_panel";
const position = {
    my: "right bottom",
    at: "left bottom",
    of: `#${methodsBottomPanelId}`,
    offset: {
        x: -12,
        y: 0
    }
};
export default function MethodsBottomPanel(props) {
    const popoverRef = useRef(null);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
        return () => {
            props.onSetShowScriptEditorPanel && props.onSetShowScriptEditorPanel(false);
        };
    }, []);
    useEffect(() => {
        !props.menuExpanded &&
            props.onSetShowScriptEditorPanel &&
            props.onSetShowScriptEditorPanel(false);
    }, [props.menuExpanded]);
    const handleHideSubMenu = useCallback(() => {
        var _a;
        if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
            props.onSetShowScriptEditorPanel && props.onSetShowScriptEditorPanel(false);
            popoverRef.current.instance.hide();
        }
    }, []);
    const handleStartMethods = useCallback(() => {
        props.activeDocumentId &&
            props.onRunMethods &&
            props.onRunMethods(props.activeDocumentId, values(props.selectedMethods));
    }, [props.onRunMethods, props.activeDocumentId, props.selectedMethods]);
    const handleOpenCreateScriptPanel = useCallback((methods, targetSelector) => {
        props.onSetShowScriptEditorPanel &&
            props.onSetShowScriptEditorPanel(true, { ...NEW_SCRIPT, Methods: methods }, targetSelector);
    }, [props.onSetShowScriptEditorPanel]);
    const hasSelectedMethods = size(props.selectedMethods) !== 0;
    const openCreateScriptPanel = useCallback(() => {
        handleOpenCreateScriptPanel(map(props.selectedMethods, "method"), `#${methodsBottomPanelId}`);
    }, [methodsBottomPanelId, props.selectedMethods]);
    return hasSelectedMethods ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container, id: methodsBottomPanelId },
            React.createElement("div", { className: styles.top },
                React.createElement("div", { className: styles["methods-container"] },
                    React.createElement("span", { className: styles.methods }, locale.buildSelected(size(props.selectedMethods), size(flatMap(props.selectedMethods, "nodesSource")))),
                    React.createElement(Button, { onClick: () => {
                            var _a;
                            if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
                                const { instance } = popoverRef.current;
                                instance.toggle(!instance.option("visible"));
                            }
                        }, styleType: "text", size: "28", iconOnly: true },
                        React.createElement("i", { className: "icon-cog-filled" }))),
                React.createElement(Button, { styleType: "tonal", onClick: props.onClear, size: "36" },
                    React.createElement("span", null, locale.CLEAR))),
            React.createElement(Button, { onClick: openCreateScriptPanel, styleType: "outlined", size: "44" },
                React.createElement("span", null, locale.CREATE_SCRIPT)),
            React.createElement(Button, { onClick: handleStartMethods, styleType: "filled", size: "44" },
                React.createElement("span", null, locale.START_METHODS))),
        props.menuExpanded && (React.createElement(Popover, { popoverRef: popoverRef, position: position, showEvent: "none", popoverHeight: props.menuExpandedHeight, popoverClassName: "no-border p-0 no-popover-arrow", popoverContent: React.createElement(MethodsSubMenu, { height: "100%", onHide: handleHideSubMenu, selectedMethods: props.selectedMethods, onSetMethodSelected: props.onSetMethodSelected, onClear: props.onClear, documentObjects: props.documentObjects, onOpenCreateScriptPanel: handleOpenCreateScriptPanel }), zIndex: parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 3 })))) : null;
}
